
	import {
		formatDateTime,
		MeasurementSchedule,
		RoutineMeasurement,
	} from "@/domain/entities/EntityFields";
	import { computed, defineComponent, PropType } from "vue";
	import DoctorWomanIcon from "@/assets/DoctorWomanIcon.vue";

	export default defineComponent({
		components: {
			DoctorWomanIcon,
		},
		props: {
			schedules: {
				type: Object as PropType<MeasurementSchedule>,
				default: () => null,
            },
            isDoctor: {
                type: Boolean,
                value: false
            }
		},
		setup(props) {
			let items = computed(() => {
				return (
					props?.schedules?.routine?.map((e: RoutineMeasurement) =>
						e.takeMeasureTime.split(":")
					) || []
				);
			});
			
			let createdAt = computed(() => {
				if (props.schedules == null) return ''
				if (props.schedules.createdAt.toDate != undefined) {
					return formatDateTime(props.schedules.createdAt.toDate())
				}
				return ''
			})
			return {
				items,
				createdAt,
				// formatDateTime,
			};
		},
	});
